import React from 'react';
import { Link } from '@sitecore-jss/sitecore-jss-react';
import { JavaScriptLinkConstants } from '../../Constants';
import { useInternalNavigate } from './useNavigate';

const JavaScriptLink = ({ field, className, dataTestId }) => {
  const navigate = useInternalNavigate();

  if (!field || !field.value) {
    return null;
  }

  const href = field.value.href || '';
  const text = field.value.text || '';

  const safeActions = {
    [`history.go(${JavaScriptLinkConstants.GO_BACK_ONE})`]: () =>
      window.history.go(JavaScriptLinkConstants.GO_BACK_ONE),
    [`history.go(${JavaScriptLinkConstants.GO_BACK_TWO})`]: () =>
      window.history.go(JavaScriptLinkConstants.GO_BACK_TWO),
    'history.back()': () => window.history.back(),
    'history.forward()': () => window.history.forward(),
    'scroll.top()': () => window.scrollTo(0, 0),
  };

  const cleansedHref = href.startsWith('http://') ? href.substring('http://'.length) : href;

  const jsText = `${JavaScriptLinkConstants.JAVASCRIPT_Text}:`;
  if (cleansedHref.startsWith(jsText)) {
    const jsAction = cleansedHref.substring(jsText.length).trim();

    if (safeActions[jsAction]) {
      return (
        <button
          type="button"
          className={className}
          data-testid={dataTestId}
          onClick={safeActions[jsAction]}
        >
          {text}
        </button>
      );
    }
    return null;
  }

  // Else, return Sitecore Link if it's a valid URL
  if (cleansedHref.startsWith('/')) {
    const navigateToLink = () => {
      navigate(cleansedHref);
    };

    return (
      <a className={className} data-testid={dataTestId} onClick={navigateToLink}>
        {text}
      </a>
    );
  }
  return <Link field={field} className={className} data-testid={dataTestId} />;
};

export default JavaScriptLink;
